module.exports = __webpack_public_path__ + "static/media/PM56.29215fc7.png";